import { render, staticRenderFns } from "./crash.vue?vue&type=template&id=5e299a32&"
import script from "./crash.vue?vue&type=script&lang=js&"
export * from "./crash.vue?vue&type=script&lang=js&"
import style0 from "./crash.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports